import http from "../../../network/HTTPClient";

const SalaryCalculationRepository = {
  async getAllEmployee() {
    const response = await http.post("employee/getAll");
    return response.data;
  },
  async getAllPeriod() {
    const response = await http.post("salary_period/all");
    return response.data;
  },
  async process(data) {
    const response = await http.post("salary_calculation/process/lama", data);
    return response.data;
  },
};

export default SalaryCalculationRepository;
